import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { enterDemo } from '../../store/slices/demo';

/**
 * "Demo Account" entry button shown in the Login screen's right panel.
 * Pulled out of LoginScreen so the screen doesn't carry any demo-mode wiring.
 */
const DemoEntryButton = () => {
  const dispatch = useDispatch();
  const [hovered, setHovered] = useState(false);

  const handleClick = useCallback(() => {
    dispatch(enterDemo());
  }, [dispatch]);

  return (
    <button
      type="button"
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        marginLeft: 'auto',
        height: 32,
        padding: '0 14px',
        background: hovered ? 'rgba(255,255,255,.06)' : 'transparent',
        color: hovered ? '#fff' : '#a0a0a0',
        fontFamily: 'Kanit, sans-serif',
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '.18em',
        textTransform: 'uppercase',
        border: `1px solid ${hovered ? '#a0a0a0' : '#5a5a5a'}`,
        cursor: 'pointer',
        transition: 'background .12s, color .12s, border-color .12s',
      }}
    >
      Demo Account ›
    </button>
  );
};

export default DemoEntryButton;
